var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1FBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3481 27.8059C20.9867 28.1442 20.5037 28.3334 20.0009 28.3334C19.4982 28.3334 19.0152 28.1442 18.6537 27.8059C15.3442 24.6884 10.909 21.2058 13.0719 16.1497C14.2414 13.416 17.0486 11.6667 20.0009 11.6667C22.9532 11.6667 25.7605 13.416 26.93 16.1497C29.0902 21.1994 24.6658 24.6991 21.3481 27.8059Z",
    stroke: "#003E3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9167 19.1667C22.9167 20.7775 21.6108 22.0833 20 22.0833C18.3892 22.0833 17.0833 20.7775 17.0833 19.1667C17.0833 17.5558 18.3892 16.25 20 16.25C21.6108 16.25 22.9167 17.5558 22.9167 19.1667Z",
    stroke: "#003E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.813784e0d3bd455a1a0c4b1164d30a43.svg";
export { ForwardRef as ReactComponent };